/**
 * Lo que pasó con las jornadas de un horario al guardarlo o regenerarlo (0325). Lo arma `refreshSchedulePositions`.
 */
export interface AjusteJornadas {
  /** Abiertas que cambiaban de hora, tarifa o tienda y se pusieron al día. */
  updated: number;
  /** Abiertas que el horario ya no pide y se quitaron (archivadas en `positions_borradas`). */
  deleted: number;
  /** Las que el horario pide y faltaban. */
  inserted: number;
  /** Con persona (asignada o cerrada) que ya no calzan con el horario: no se tocan. */
  locked: number;
  /** Abiertas que el horario ya no pide pero tienen alguna postulación, aunque sea rechazada: se conservan. */
  kept: number;
}

const n = (k: number, uno: string, varios: string): string => `${k} ${k === 1 ? uno : varios}`;

/**
 * El aviso que ve quien guardó el horario. Existe porque el 21-oct Roberto cambió los horarios de Pringles a
 * fechas puntuales y nada le dijo que 63 jornadas viejas seguían ahí: el ajuste no puede volver a ser invisible.
 * Sin cambios también se dice, para que el silencio no se lea como «no pasó nada porque no funcionó».
 */
export function textoAjusteJornadas(tienda: string, r: AjusteJornadas): string {
  const partes: string[] = [];
  if (r.inserted > 0) partes.push(n(r.inserted, 'creada', 'creadas'));
  if (r.deleted > 0) {
    partes.push(`${n(r.deleted, 'quitada', 'quitadas')} porque el horario ya no ${r.deleted === 1 ? 'la' : 'las'} pide`);
  }
  if (r.updated > 0) partes.push(`${n(r.updated, 'puesta', 'puestas')} al día con la hora y la tarifa nuevas`);

  let texto = `Horario de ${tienda} guardado.`;
  if (partes.length > 0) texto += ` Jornadas: ${partes.join(', ')}.`;
  if (r.locked > 0) {
    texto += r.locked === 1
      ? ' 1 con persona asignada ya no calza con el horario y no se tocó: revísala en Asignaciones.'
      : ` ${r.locked} con persona asignada ya no calzan con el horario y no se tocaron: revísalas en Asignaciones.`;
  }
  if (r.kept > 0) {
    texto += r.kept === 1
      ? ' 1 jornada que el horario ya no pide tiene una postulación (aunque sea rechazada) y se conservó.'
      : ` ${r.kept} jornadas que el horario ya no pide tienen alguna postulación (aunque sea rechazada) y se conservaron.`;
  }
  if (partes.length === 0 && r.locked === 0 && r.kept === 0) texto += ' Sus jornadas ya estaban al día.';
  return texto;
}
